import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import useStore from '../../store';
import { LiliTransaction } from '../../pages/TransactionsFacelift/types/lili-transaction';

const { CONTROLLERS: { TAX_BUCKET_TRANSACTIONS: { BASE, VERSION } } } = USER;

export const useTaxBucketTransactionsQuery = ({ customerId, query }: { customerId: string, query: string, }) => useQuery(
  'tax-bucket-transactions',
  async () => {
    if (!customerId || !query) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}?${query}`));
    return data;
  },
  {
    onSuccess: (data) => {
      const { setTransactionsList } = useStore.getState();
      setTransactionsList(data.transactionList as LiliTransaction[]);
    },
  },
);
